import {
    hasOAuthErrorCallback,
    hasOAuthSuccessCallback,
    isSessionValid,
} from '@/shared/utils/auth.ts';
import {redirect} from 'react-router';
import {ROUTE_PATHS} from './routePaths.ts';

/**
 * Loader that requires authentication.
 * Redirects to login if session is not valid.
 * Used for all protected routes (/recepcionista, /profissional, /admin).
 */
export const requireAuth = () => {
    // Don't redirect if successful OAuth callback is in progress
    // For OAuth errors, allow redirect to login
    if (hasOAuthSuccessCallback()) {
        return null;
    }

    if (!isSessionValid()) {
        throw redirect(ROUTE_PATHS.LOGIN);
    }

    return null;
};

/**
 * Loader for the login page.
 * Redirects to root if user has a valid session.
 */
export const redirectIfAuthenticated = () => {
    // Don't redirect if successful OAuth callback is in progress - let it complete
    // For OAuth errors, stay on login page
    if (hasOAuthSuccessCallback()) {
        return null;
    }

    if (isSessionValid()) {
        throw redirect(ROUTE_PATHS.ROOT);
    }

    return null;
};

/**
 * Loader for the root path.
 * Returns auth state for the component to handle role-based redirect.
 */
export const rootLoader = () => {
    // If successful OAuth callback in progress, treat as potentially authenticated
    // The component will wait for AuthContext to process the session
    if (hasOAuthSuccessCallback()) {
        return {isAuthenticated: true, isOAuthCallback: true};
    }

    // If OAuth error callback, treat as unauthenticated
    // AuthContext will handle clearing the hash
    if (hasOAuthErrorCallback()) {
        return {isAuthenticated: false, isOAuthCallback: true};
    }

    return {isAuthenticated: isSessionValid(), isOAuthCallback: false};
};
